/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseSlidePanel.vue?vue&type=template&id=2b869cc2&scoped=true"
import script from "./BaseSlidePanel.vue?vue&type=script&lang=js"
export * from "./BaseSlidePanel.vue?vue&type=script&lang=js"
import style0 from "./BaseSlidePanel.vue?vue&type=style&index=0&id=2b869cc2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b869cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b869cc2')) {
      api.createRecord('2b869cc2', component.options)
    } else {
      api.reload('2b869cc2', component.options)
    }
    module.hot.accept("./BaseSlidePanel.vue?vue&type=template&id=2b869cc2&scoped=true", function () {
      api.rerender('2b869cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BaseSlidePanel.vue"
export default component.exports